import { useContext } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Can } from '../Can';
import { SmallButton } from '../common/forms/FormElements';
import CommonContext from '../Common';

export const EmployeePreferredForemanInfo = ({ preferredForemen, onAdd, onEdit }) => {
    const { formIsOpen } = useContext(CommonContext);
    const foremen = preferredForemen ?? [];

    return (
        <>
            <Row className="pb-1">
                <Col>
                    <div className="d-flex flex-row align-items-center justify-content-end">
                        <Can
                            I="edit"
                            a="employee"
                        >
                            <SmallButton
                                disabled={!!formIsOpen}
                                type="button"
                                onClick={onAdd}
                            >
                                <i className="fa fa-plus-circle fa-md mr-2" />
                                Add Preferred Foreman
                            </SmallButton>
                        </Can>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <table className="table table-sm table-bordered">
                        <thead className="text-muted">
                            <tr>
                                <th>Foreman</th>
                                <th>Company</th>
                                <th>Email</th>
                                <Can
                                    I="edit"
                                    a="employee"
                                >
                                    <th
                                        className="text-center"
                                        style={{ width: '70px' }}
                                    />
                                </Can>
                            </tr>
                        </thead>
                        <tbody>
                            {!foremen.length ? (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="text-center text-muted"
                                    >No preferred foremen added.</td>
                                </tr>
                            ) : foremen.map((foreman) => (
                                <tr key={foreman.id}>
                                    <td>{foreman.foremanName}</td>
                                    <td>{foreman.companyName}</td>
                                    <td>{foreman.email}</td>
                                    <Can
                                        I="edit"
                                        a="employee"
                                    >
                                        <td className="text-center">
                                            <Button
                                                disabled={!!formIsOpen}
                                                type="button"
                                                color="outline-primary"
                                                onClick={() => onEdit(foreman)}
                                                size="sm"
                                            >
                                                Edit
                                            </Button>
                                        </td>
                                    </Can>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Col>
            </Row>
        </>
    );
};

export default EmployeePreferredForemanInfo;
